import React from 'react';
import ReactDOM from 'react-dom';
import './index.sass';
import * as serviceWorker from './serviceWorker';
import WeatherContainer from './container/WeatherContainer/WeatherContainer';

import 'bootstrap/dist/css/bootstrap.min.css';
import './mock-server/server'

ReactDOM.render(
  <React.StrictMode>
    <WeatherContainer/>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
